import { render, staticRenderFns } from "./setAccount.vue?vue&type=template&id=b73c004e&scoped=true"
import script from "./setAccount.vue?vue&type=script&lang=js"
export * from "./setAccount.vue?vue&type=script&lang=js"
import style0 from "./setAccount.vue?vue&type=style&index=0&id=b73c004e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b73c004e",
  null
  
)

export default component.exports